import { Grid } from "@material-ui/core";
import {
    riskLevelToColor,
    tempExcursionColors,
} from "components/TotalsWidget/colorsMapping";
import TotalWidget from "components/TotalsWidget/TotalWidget";
import { productTypeWidgetFormatting } from "helpers/productTypeStringFormatting";
import { separateThousands } from "helpers/separateThousands";
import { observer } from "mobx-react";
import { RiskLevel } from "models/enums/RiskLevel";
import { globalViewStyles } from "pages/GlobalView/GlobalViewStyles";
import React from "react";
import { useStore } from "store/StoreConfigs";

export const LaneViewTotalsWidgetsWrapper = observer(
    function TotalsWidgetsWrapper() {
        const classes = globalViewStyles();

        const defaultSegment = [
            {
                count: 100,
                color: "rgba(240, 241, 249, 1)",
                centerTitle: `No Data`,
                centerSubtitle: `😵`,
            },
        ];
        const defaultExcursionSegment = [
            {
                count: 100,
                color: "rgba(240, 241, 249, 1)",
                centerTitle: `0 Excursions `,
                centerSubtitle: `🎉`,
            },
        ];

        const {
            laneStore: {
                routeAggregations,
                productExcursionsList: productExcursions,
                loadingAggregations,
                loadingTemperatureExcursions,
            },
        } = useStore();

        const routesTotal = routeAggregations.reduce(
            (sum, curr) => sum + curr.countOfRoutes,
            0
        );

        const routeHealthSegments = routeAggregations
            .filter((x) => x.countOfRoutes > 0)
            .map((x) => ({
                count: x.countOfRoutes,
                color: riskLevelToColor(x.riskLevel),
                centerTitle: `${Math.round(
                    (x.countOfRoutes / routesTotal) * 100
                )}%`,
                centerSubtitle:
                    x.riskLevel === "HEALTHY"
                        ? `No risk`
                        : `${RiskLevel[x.riskLevel].toLowerCase()} risk`,
                tooltipTitle: `${x.countOfRoutes}`,
                tooltipSubtitle: x.countOfRoutes === 1 ? "Route" : "Routes",
            }));

        const shipmentsTotal = routeAggregations.reduce(
            (sum, curr) => sum + curr.countOfShipments,
            0
        );

        const shipmentHealthSegments = routeAggregations
            .filter((x) => x.countOfShipments > 0)
            .map((x) => ({
                count: x.countOfShipments,
                color: riskLevelToColor(x.riskLevel),
                centerTitle: `${Math.round(
                    (x.countOfShipments / shipmentsTotal) * 100
                )}%`,
                centerSubtitle:
                    x.riskLevel === "HEALTHY"
                        ? `No risk`
                        : `${RiskLevel[x.riskLevel].toLowerCase()} risk`,
                tooltipTitle: `${x.countOfShipments}`,
                tooltipSubtitle:
                    x.countOfShipments === 1 ? "Shipment" : "Shipments",
            }));

        const tempExcursionsTotal = productExcursions.reduce(
            (sum, curr) => sum + curr.excursionCount,
            0
        );

        const tempExcursionsSegments = productExcursions.map((x, index) => ({
            count: x.excursionCount,
            color: tempExcursionColors[index],
            centerTitle: `${Math.round(
                (x.excursionCount / tempExcursionsTotal) * 100
            )}%`,
            centerSubtitle: "of excursions",
            tooltipTitle: `${x.excursionCount} ${
                x.excursionCount === 1 ? "excursion" : "excursions"
            }`,
            tooltipSubtitle: productTypeWidgetFormatting(x.productType),
        }));

        return (
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                className={classes.section}
            >
                <TotalWidget
                    title="route health"
                    centerTitle={
                        routesTotal === 0
                            ? "No Data"
                            : separateThousands(routesTotal)
                    }
                    centerSubtitle={routesTotal === 0 ? "😵" : "total routes"}
                    segments={
                        routesTotal === 0 ? defaultSegment : routeHealthSegments
                    }
                    showTooltips={routesTotal !== 0}
                    isLoading={loadingAggregations}
                />
                <TotalWidget
                    title="shipment health"
                    centerTitle={
                        shipmentsTotal === 0
                            ? "No Data"
                            : separateThousands(shipmentsTotal)
                    }
                    centerSubtitle={
                        shipmentsTotal === 0 ? "😵" : "total shipments"
                    }
                    segments={
                        shipmentsTotal === 0
                            ? defaultSegment
                            : shipmentHealthSegments
                    }
                    showTooltips={shipmentsTotal !== 0}
                    isLoading={loadingAggregations}
                />
                <TotalWidget
                    title="shipments impacted by temp excursions"
                    centerTitle={
                        tempExcursionsTotal === 0
                            ? "0 Excursions "
                            : tempExcursionsTotal.toString()
                    }
                    centerSubtitle={
                        tempExcursionsTotal === 0
                            ? "🎉"
                            : tempExcursionsTotal === 1
                            ? "temp excursion"
                            : "temp excursions"
                    }
                    showTooltips={tempExcursionsTotal !== 0}
                    segments={
                        tempExcursionsTotal === 0
                            ? defaultExcursionSegment
                            : tempExcursionsSegments
                    }
                    isLoading={loadingTemperatureExcursions}
                />
            </Grid>
        );
    }
);
